// extracted by mini-css-extract-plugin
export default {"errorMessagePointer":"NumberField-module__errorMessagePointer--Gxb4n","numberInput":"NumberField-module__numberInput--UwVd0"};